import PropTypes from 'prop-types';
import React from 'react';
import Card from './Card';

require('./style.scss');

const FeaturedCard = props =>
  <div
    id={props.id}
    className="card featured"
    style={{ backgroundColor: props.backgroundColor }}
  >
    {props.children}
  </div>;

FeaturedCard.Content = Card.Content;
FeaturedCard.Body = Card.Body;
FeaturedCard.List = Card.List;
FeaturedCard.Footer = Card.Footer;

FeaturedCard.Header = props =>
  <div
    className="card-header featured"
    style={{
      backgroundColor: props.backgroundColor,
      color: props.color,
    }}
  >
    {props.media}
    {props.title}

    {props.children ?
      <div className="meta">
        {props.children}
      </div> : null}
    <div className="actions">{props.actions}</div>
    <div className="clearfix" />
  </div>;

FeaturedCard.propTypes = {
  id: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
};

FeaturedCard.Header.propTypes = {
  actions: PropTypes.node,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  media: PropTypes.node,
  title: PropTypes.node,
};


module.exports = FeaturedCard;



// WEBPACK FOOTER //
// ./app/components/common/card/FeaturedCard.jsx